import PropTypes from "prop-types"

export const Google = ({ height = 24, width = 24, fill = "#272A34", ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 246 246"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_2538_1929)">
      <path
        d="M132.322 0C135.244 1.09561 138.364 0.929067 141.388 1.40319C162.801 4.69149 182.96 13.5989 199.808 27.2173C200.833 28.0374 200.916 28.4283 199.808 29.3061C187.357 39.4335 174.936 49.6037 162.544 59.8166C161.404 60.7584 160.622 60.4573 159.61 59.8166C148.142 53.0329 135.015 49.5661 121.693 49.8023C107.105 49.9983 92.9114 54.5641 80.9453 62.9097C68.9791 71.2553 59.7902 82.9973 54.5659 96.6188C54.284 97.362 53.9252 98.0732 53.6113 98.8036C49.2245 95.2541 44.8336 91.7024 40.4383 88.1487C31.5367 80.93 22.6458 73.7049 13.7656 66.4735C13.9281 66.0375 14.112 65.6099 14.3166 65.192C34.1017 29.6968 64.0014 8.44246 104.016 1.42884C107.033 0.903464 110.167 1.09563 113.095 0.01924L132.322 0Z"
        fill={fill}
      />
      <path
        d="M13.7966 66.4863C22.6896 73.7135 31.5805 80.9386 40.4693 88.1615C44.8517 91.7239 49.2427 95.2755 53.6422 98.8165C51.5663 105.935 50.0158 113.124 49.798 120.601C49.6149 130.09 51.1496 139.534 54.3278 148.478L14.7128 180.834C8.30577 169.461 4.31416 157.262 1.89869 144.48C1.13624 140.45 1.0978 136.304 -0.0234375 132.306V113.13C0.431465 112.931 0.412231 112.489 0.444267 112.13C0.79607 107.53 1.43806 102.957 2.36639 98.4384C4.7306 87.2773 8.24166 76.5134 13.7966 66.4863Z"
        fill={fill}
      />
      <path
        d="M159.604 185.76C170.266 179.219 179.037 170.774 185.45 159.972C187.235 156.858 188.85 153.65 190.288 150.361C191.095 148.593 190.57 148.234 188.789 148.241C175.443 148.298 162.103 148.241 148.757 148.241C141.709 148.241 134.7 148.196 127.665 148.241C126.044 148.241 125.455 147.837 125.461 146.113C125.525 131.334 125.525 116.553 125.461 101.77C125.461 100.04 126.038 99.6621 127.659 99.6621C165.533 99.7006 203.405 99.7006 241.275 99.6621C242.89 99.6621 243.403 100.168 243.652 101.77C249.543 139.175 240.485 172.491 216.48 201.721C211.512 207.879 205.808 213.405 199.495 218.174C198.495 217.386 197.483 216.611 196.49 215.803L159.604 185.76Z"
        fill={fill}
      />
      <path
        d="M159.61 185.76L196.495 215.873C197.489 216.68 198.501 217.456 199.5 218.244C191.376 225.195 182.246 230.539 172.52 234.864C152.934 243.565 132.38 247.178 111.108 244.801C68.3218 240.028 36.28 218.583 14.874 181.236C14.8048 181.092 14.7552 180.939 14.7266 180.782L54.3416 148.426C58.1858 157.902 63.4588 166.468 70.6668 173.791C81.8196 185.151 96.3814 192.552 112.132 194.865C127.882 197.179 143.957 194.278 157.906 186.606C158.463 186.343 159.04 186.074 159.61 185.76Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_2538_1929">
        <rect width="245.391" height="245.551" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

Google.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  fill: PropTypes.string
}
